import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Zap } from 'lucide-react';
export function MidPageCTA() {
  return <section className="py-20 bg-navy-900 text-cream-50 relative overflow-hidden border-y border-navy-800" data-id="element-92">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gold-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-93" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-94">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-95">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center md:text-left space-y-6" data-id="element-96">
            <h2 className="text-3xl md:text-4xl font-bold font-serif leading-tight" data-id="element-97">
              Una sola sorpresa en tu cierre te puede costar <br data-id="element-98" />
              <span className="text-red-400 bg-red-900/20 px-2 rounded" data-id="element-99">
                $1,500–$4,000
              </span>
            </h2>

            <p className="text-xl text-cream-200/90" data-id="element-100">
              Este sistema completo cuesta{' '}
              <span className="text-gold-400 font-bold text-2xl" data-id="element-101">$6.36</span>.{' '}
              <br data-id="element-102" />
              Haz la cuenta.
            </p>

            <div className="pt-4 flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-103">
              <a href="#pricing" onClick={e => {
              e.preventDefault();
              const target = document.getElementById('pricing');
              if (!target) return;
              const start = window.scrollY;
              const end = target.getBoundingClientRect().top + start - 40;
              const duration = 2800;
              const startTime = performance.now();
              const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
              const animate = (currentTime: number) => {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
                if (progress < 1) requestAnimationFrame(animate);
              };
              requestAnimationFrame(animate);
            }} className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-navy-900 bg-gold-500 rounded-lg hover:bg-gold-400 transition-all duration-300 shadow-[0_0_20px_rgba(201,168,76,0.3)] hover:shadow-[0_0_30px_rgba(201,168,76,0.5)] transform hover:-translate-y-1" data-id="element-104">
                Quiero cerrar con control — $6.36
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-105" />
              </a>
            </div>

            <div className="flex items-center justify-center md:justify-start gap-6 text-sm text-cream-200/60 pt-2" data-id="element-106">
              <div className="flex items-center" data-id="element-107">
                <Zap className="w-4 h-4 mr-2 text-gold-500" data-id="element-108" />
                Descarga inmediata
              </div>
              <div className="flex items-center" data-id="element-109">
                <ShieldCheck className="w-4 h-4 mr-2 text-gold-500" data-id="element-110" />
                Pago seguro
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative flex justify-center" data-id="element-111">
            <div className="absolute inset-0 bg-gold-500/20 blur-2xl rounded-full transform scale-75" data-id="element-112" />
            <img src="https://cdn.magicpatterns.com/uploads/m6edm9okwdZWtRcsRtXryr/heylloyd-image-1770865285128.png" alt="Cash-to-Close Sin Ansiedad Bundle" className="relative w-3/4 md:w-full h-auto rounded-lg shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-113" />
          </motion.div>
        </div>
      </div>
    </section>;
}